/*
 * PDP image carousel midline navigation — added 2026-08-19 (FINE)
 * The native cursor is hidden over the PDP image; a custom caret element
 * follows the mouse and rotates 180° (over the top) as the pointer crosses
 * the image midline. Clicking pages the swiper in the caret's direction.
 * Dots and drag keep working; drags don't misfire clicks (swiper clears
 * allowClick during a drag). Styles live in snippets/product-images.liquid.
 */
(function () {
  'use strict';

  function wire(container) {
    var caret = document.createElement('span');
    caret.className = 'pdp-cursor';
    caret.setAttribute('aria-hidden', 'true');
    caret.innerHTML =
      '<svg class="pdp-cursor__glyph" width="26" height="26" viewBox="0 0 32 32">' +
      '<path d="M21 5 L10 16 L21 27" fill="none" stroke="black" stroke-width="3"/>' +
      '</svg>';
    document.body.appendChild(caret);

    var visible = false;

    function hide() {
      visible = false;
      caret.classList.remove('pdp-cursor--visible');
    }

    container.addEventListener('mousemove', function (event) {
      // Over the dots the native cursor returns and the caret hides.
      if (event.target.closest('.swiper-pagination')) {
        hide();
        return;
      }

      var rect = container.getBoundingClientRect();
      var isNext = event.clientX >= rect.left + rect.width / 2;

      if (!visible) {
        // First appearance: snap to the correct direction without animating.
        caret.classList.add('pdp-cursor--no-transition');
        caret.classList.toggle('pdp-cursor--next', isNext);
        void caret.offsetWidth;
        caret.classList.remove('pdp-cursor--no-transition');
        caret.classList.add('pdp-cursor--visible');
        visible = true;
      } else {
        caret.classList.toggle('pdp-cursor--next', isNext);
      }

      caret.style.transform = 'translate(' + (event.clientX - 13) + 'px, ' + (event.clientY - 13) + 'px)';
    });

    container.addEventListener('mouseleave', hide);

    container.addEventListener('click', function (event) {
      if (event.target.closest('.swiper-pagination')) return;
      var sw = container.swiper;
      if (!sw || sw.allowClick === false) return;
      var rect = container.getBoundingClientRect();
      if (event.clientX < rect.left + rect.width / 2) {
        sw.slidePrev();
      } else {
        sw.slideNext();
      }
    });
  }

  function init() {
    document.querySelectorAll('.product-images.imageSwiper').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
